import {MODULE_LAYOUT} from '../index';
import ContentLayoutComponent from './component/content.layout.component';
export const MODULE_CONTENT_LAYOUT = MODULE_LAYOUT + '.content';

angular.module(MODULE_CONTENT_LAYOUT, []);

angular.module(MODULE_CONTENT_LAYOUT)
	.component(ContentLayoutComponent.META.name, new ContentLayoutComponent());

angular.module(MODULE_CONTENT_LAYOUT)
	.config(contentLayoutConfig);


function contentLayoutConfig($stateProvider) {
	$stateProvider
		.state(ContentLayoutComponent.META.state);
}

contentLayoutConfig.$inject = ['$stateProvider'];




// WEBPACK FOOTER //
// ./modules/distribution/layouts/content/index.js